import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../libs/shared/ui/src/styles/mixins';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';
import {
  noSchedulingLinksSubtitleCopy,
  noSchedulingLinksTitleCopy,
  schedulingLearnMoreUrl,
} from './schedulingLinkViewHelpers';

/*
 * Props.
 */

interface SchedulingLinksEmptyProps {}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
`;

const StyledTextDiv = styled.div`
  ${center()}
  text-align: center;
  padding: 30px;
`;

const StyledTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  margin-bottom: 6px;
  line-height: 25px;
`;

const StyledSubtitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.normal};
  line-height: 20px;
`;

const StyledButton = styled(Button)`
  display: flex;
  margin-top: 4px;
`;

const StyledButtonContentDiv = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  font-size: ${fontSizes.small};
`;

const StyledLearnMoreIcon = styled(Icon)`
  margin-left: 5px;
`;

/*
 * Component.
 */

export const SchedulingLinksEmpty: FC<SchedulingLinksEmptyProps> = (props) => {
  const onLearnMoreClick = () => {
    openInBrowser(schedulingLearnMoreUrl);
  };

  return (
    <StyledWrapperDiv>
      <StyledTextDiv>
        <StyledTitleDiv>{noSchedulingLinksTitleCopy}</StyledTitleDiv>
        <StyledSubtitleDiv>{noSchedulingLinksSubtitleCopy}</StyledSubtitleDiv>
        <StyledButton onClick={onLearnMoreClick} variant={ButtonVariantsEnum.LINK}>
          <StyledButtonContentDiv>
            <Trans id="scheduling-learn-more">Learn more</Trans>
            <StyledLearnMoreIcon name="externalLinkSmall" />
          </StyledButtonContentDiv>
        </StyledButton>
      </StyledTextDiv>
    </StyledWrapperDiv>
  );
};
